type WorkTemplateLabelInput = {
  name: string;
  lenderCompanyName?: string | null;
};

export const getWorkTemplateLabel = (
  workTemplate: WorkTemplateLabelInput,
  isLimitedCompany: boolean
): string => {
  if (isLimitedCompany && workTemplate.lenderCompanyName) {
    return `${workTemplate.name} — ${workTemplate.lenderCompanyName}`;
  }
  return workTemplate.name;
};
